/*
 * The logged in company (Company model from the API).
 * Reports use its timezone so day/month boundaries match the business, not the
 * browser of whoever runs the report.
 */
import companyServices from 'src/services/companyServices';
import { browserTimezone, isValidTimezone } from 'src/util/timezone';

const state = {
  company: undefined,
};

const getters = {
  getCompany: (state) => state.company,
  // Company default timezone (an IANA zone), or the browser's if it is not set
  getCompanyTimezone: (state) =>
    isValidTimezone(state.company?.timezone)
      ? state.company.timezone
      : browserTimezone(),
};

const actions = {
  async fetchCompany({ commit, state }) {
    // Only load the data once
    if (state.company == undefined) {
      return companyServices
        .fetchMyCompany()
        .then((r) => {
          commit('setCompany', r.data);
        })
        .catch((e) => {
          // Don't fail the whole config load, reports fall back to the browser timezone
          console.error('Unable to load company', e);
        });
    }
  },
  unloadCompany({ commit }) {
    commit('setCompany', undefined);
  },
};

const mutations = {
  setCompany(state, company) {
    state.company = company;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
